var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"controls",attrs:{"id":"pac-input","type":"text","placeholder":_vm.$t('search')}}),_vm._v(" "),_c('div',{ref:"googleMap",staticClass:"google-map w-full",staticStyle:{"height":"400px"}}),_vm._v(" "),(Boolean(this.google) && Boolean(this.map))?[_vm._t("default",null,{"google":_vm.google,"map":_vm.map})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }